import { Checkbox, MenuItem, Typography } from '@mui/material';

import { SearchContext } from 'context/SearchContext';
import { transformFacetValue } from 'helpers/Search';
import { useContext } from 'react';
import { Facet } from 'types/Search';
interface Props {
  selectedFilterOption: string;
  filter: { value: string; count: number };
}
export const SingleSearchFilterItem: React.FC<Props> = ({
  selectedFilterOption,
  filter
}) => {
  const { request: searchRequest, handleToggleFilter } =
    useContext(SearchContext);
  const getFacetLabel = (option: string, facetOption: Facet) =>
    transformFacetValue(option, facetOption) +
    (option !== 'document_types' ? ' (' + facetOption.count + ')' : '');
  return (
    <MenuItem
      key={filter.value}
      onClick={() => handleToggleFilter(filter.value, selectedFilterOption)}
      sx={{
        pl: 0
      }}
      dense
      title={
        [...getFacetLabel(selectedFilterOption, filter)]?.length >= 29
          ? getFacetLabel(selectedFilterOption, filter)
          : undefined
      }
    >
      <Checkbox
        sx={{ py: 0, px: 0.5 }}
        size="small"
        disableRipple
        checked={searchRequest?.filters?.some(el => el.value === filter.value)}
      />
      <Typography variant="caption" noWrap>
        {getFacetLabel(selectedFilterOption, filter)}
      </Typography>
    </MenuItem>
  );
};
